import { useCallback, useEffect, useRef, useState } from "react";
import { type Location, useLocation } from "react-router-dom";

export function useLoadOncePerLocation() {
  const location = useLocation();
  const prev = useRef<Location<unknown>>();
  const [loadedLocation, setLoadedLocation] = useState<Location | null>(null);
  const [loadRequested, setLoadRequested] = useState<Location | null>(null);

  useEffect(() => {
    setLoadedLocation(loadRequested);
  }, [loadRequested]);

  useEffect(() => {
    if (!location) return;

    setLoadedLocation(null);
  }, [location]);

  const load = useCallback(() => {
    if (prev.current !== location) {
      setLoadRequested(location);
      prev.current = location;
    }
  }, [location]);

  return {
    load,
    loadedLocation,
  };
}
